<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12">
      <h1>{{ title() }}</h1>
    </div>
  </div>
</div>
